export default {
  "content": "<g clip-path=\"url(#clip0_21112_743)\" fill=\"#7B61FF\"><path d=\"M23.707 11.293a1.001 1.001 0 010 1.414L18.415 18 17 16.586 20.586 13H8v-2h12.586L17 7.413 18.414 6l5.293 5.294zM2 16h9v2H2v-2zM5 6h9v2H5V6z\"/></g><defs><clipPath id=\"clip0_21112_743\"><path fill=\"#fff\" d=\"M0 0h24v24H0z\"/></clipPath></defs>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};